module.exports = __webpack_public_path__ + "img/gbwhatsapp-anti-ban.b8e6777d.webp";